/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation } from "@aws-amplify/api";
import { GraphQLResult } from "@aws-amplify/api/lib/types";
import * as Observable from "zen-observable";

export type PutRequestRecordMutation = {
  __typename: "RequestRecord";
  request_id: string;
  mail_address: string | null;
  expiry_time: string | null;
};

export type PutRequestRecordUuidMutation = {
  __typename: "RequestRecord";
  request_id: string;
  mail_address: string | null;
  expiry_time: string | null;
};

export type PutRequestRecordUuidEmptyMailMutation = {
  __typename: "RequestRecord";
  request_id: string;
  mail_address: string | null;
  expiry_time: string | null;
};

export type UpdateWithdrewListMutation = {
  __typename: "WithdrewList";
  member_no: string;
  club_cd: string | null;
  surname_cc: string | null;
  firstname_cc: string | null;
  surname_js: string | null;
  firstname_js: string | null;
  birthday: string | null;
  post_no: string | null;
  mail_address: string | null;
  request_id: string | null;
  processed_flag: string | null;
  processed_time: string | null;
  linked_flag: string | null;
  start_time: string | null;
  linked_time: string | null;
  shop_name: string | null;
  resume_flag: boolean | null;
};

export type UpdateWithdrewListLinkedMutation = {
  __typename: "WithdrewList";
  member_no: string;
  club_cd: string | null;
  surname_cc: string | null;
  firstname_cc: string | null;
  surname_js: string | null;
  firstname_js: string | null;
  birthday: string | null;
  post_no: string | null;
  mail_address: string | null;
  request_id: string | null;
  processed_flag: string | null;
  processed_time: string | null;
  linked_flag: string | null;
  start_time: string | null;
  linked_time: string | null;
  shop_name: string | null;
  resume_flag: boolean | null;
};

export type SelectMailAddressQuery = {
  __typename: "RequestRecord";
  request_id: string;
  mail_address: string | null;
  expiry_time: string | null;
};

export type GetRequestRecordQuery = {
  __typename: "RequestRecord";
  request_id: string;
  mail_address: string | null;
  expiry_time: string | null;
};

export type SelectMailWithdrewQuery = {
  __typename: "WithdrewList";
  member_no: string;
  club_cd: string | null;
  surname_cc: string | null;
  firstname_cc: string | null;
  surname_js: string | null;
  firstname_js: string | null;
  birthday: string | null;
  post_no: string | null;
  mail_address: string | null;
  request_id: string | null;
  processed_flag: string | null;
  processed_time: string | null;
  linked_flag: string | null;
  start_time: string | null;
  linked_time: string | null;
  shop_name: string | null;
  resume_flag: boolean | null;
};

export type SelectWithdrewQuery = {
  __typename: "WithdrewList";
  member_no: string;
  club_cd: string | null;
  surname_cc: string | null;
  firstname_cc: string | null;
  surname_js: string | null;
  firstname_js: string | null;
  birthday: string | null;
  post_no: string | null;
  mail_address: string | null;
  request_id: string | null;
  processed_flag: string | null;
  processed_time: string | null;
  linked_flag: string | null;
  start_time: string | null;
  linked_time: string | null;
  shop_name: string | null;
  resume_flag: boolean | null;
};

export type GetShopOperateQuery = {
  __typename: "ShopOperate";
  club_cd: string;
  shop_name: string | null;
  resume_flag: boolean | null;
};

export type SelectWithdrewAllQuery = {
  __typename: "WithdrewList";
  member_no: string;
  club_cd: string | null;
  surname_cc: string | null;
  firstname_cc: string | null;
  surname_js: string | null;
  firstname_js: string | null;
  birthday: string | null;
  post_no: string | null;
  mail_address: string | null;
  request_id: string | null;
  processed_flag: string | null;
  processed_time: string | null;
  linked_flag: string | null;
  start_time: string | null;
  linked_time: string | null;
  shop_name: string | null;
  resume_flag: boolean | null;
};

export type SelectWithdrewAllByClubQuery = {
  __typename: "WithdrewList";
  member_no: string;
  club_cd: string | null;
  surname_cc: string | null;
  firstname_cc: string | null;
  surname_js: string | null;
  firstname_js: string | null;
  birthday: string | null;
  post_no: string | null;
  mail_address: string | null;
  request_id: string | null;
  processed_flag: string | null;
  processed_time: string | null;
  linked_flag: string | null;
  start_time: string | null;
  linked_time: string | null;
  shop_name: string | null;
  resume_flag: boolean | null;
};

export type SelectWithdrew4CsvQuery = {
  __typename: "WithdrewList";
  member_no: string;
  club_cd: string | null;
  surname_cc: string | null;
  firstname_cc: string | null;
  surname_js: string | null;
  firstname_js: string | null;
  birthday: string | null;
  post_no: string | null;
  mail_address: string | null;
  request_id: string | null;
  processed_flag: string | null;
  processed_time: string | null;
  linked_flag: string | null;
  start_time: string | null;
  linked_time: string | null;
  shop_name: string | null;
  resume_flag: boolean | null;
};

export type SelectWithdrewClubCdSubscription = {
  __typename: "WithdrewList";
  member_no: string;
  club_cd: string | null;
  surname_cc: string | null;
  firstname_cc: string | null;
  surname_js: string | null;
  firstname_js: string | null;
  birthday: string | null;
  post_no: string | null;
  mail_address: string | null;
  request_id: string | null;
  processed_flag: string | null;
  processed_time: string | null;
  linked_flag: string | null;
  start_time: string | null;
  linked_time: string | null;
  shop_name: string | null;
  resume_flag: boolean | null;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async PutRequestRecord(
    mail_address: string
  ): Promise<PutRequestRecordMutation> {
    const statement = `mutation PutRequestRecord($mail_address: String!) {
        putRequestRecord(mail_address: $mail_address) {
          __typename
          request_id
          mail_address
          expiry_time
        }
      }`;
    const gqlAPIServiceArguments: any = {
      mail_address
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PutRequestRecordMutation>response.data.putRequestRecord;
  }
  async PutRequestRecordUuid(
    request_id: string,
    mail_address?: string
  ): Promise<PutRequestRecordUuidMutation> {
    const statement = `mutation PutRequestRecordUuid($request_id: String!, $mail_address: String) {
        putRequestRecordUUID(request_id: $request_id, mail_address: $mail_address) {
          __typename
          request_id
          mail_address
          expiry_time
        }
      }`;
    const gqlAPIServiceArguments: any = {
      request_id
    };
    if (mail_address) {
      gqlAPIServiceArguments.mail_address = mail_address;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PutRequestRecordUuidMutation>response.data.putRequestRecordUUID;
  }
  async PutRequestRecordUuidEmptyMail(
    request_id: string
  ): Promise<PutRequestRecordUuidEmptyMailMutation> {
    const statement = `mutation PutRequestRecordUuidEmptyMail($request_id: String!) {
        putRequestRecordUUIDEmptyMail(request_id: $request_id) {
          __typename
          request_id
          mail_address
          expiry_time
        }
      }`;
    const gqlAPIServiceArguments: any = {
      request_id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PutRequestRecordUuidEmptyMailMutation>(
      response.data.putRequestRecordUUIDEmptyMail
    );
  }
  async UpdateWithdrewList(
    request_id: string,
    member_nos?: Array<string | null>,
    club_cds?: Array<string | null>,
    processed_flag?: boolean,
    processed_time?: string,
    start_time?: string
  ): Promise<Array<UpdateWithdrewListMutation>> {
    const statement = `mutation UpdateWithdrewList($member_nos: [String], $club_cds: [String], $request_id: String!, $processed_flag: Boolean, $processed_time: String, $start_time: String) {
        updateWithdrewList(member_nos: $member_nos, club_cds: $club_cds, request_id: $request_id, processed_flag: $processed_flag, processed_time: $processed_time, start_time: $start_time) {
          __typename
          member_no
          club_cd
          surname_cc
          firstname_cc
          surname_js
          firstname_js
          birthday
          post_no
          mail_address
          request_id
          processed_flag
          processed_time
          linked_flag
          start_time
          linked_time
          shop_name
          resume_flag
        }
      }`;
    const gqlAPIServiceArguments: any = {
      request_id
    };
    if (member_nos) {
      gqlAPIServiceArguments.member_nos = member_nos;
    }
    if (club_cds) {
      gqlAPIServiceArguments.club_cds = club_cds;
    }
    if (processed_flag) {
      gqlAPIServiceArguments.processed_flag = processed_flag;
    }
    if (processed_time) {
      gqlAPIServiceArguments.processed_time = processed_time;
    }
    if (start_time) {
      gqlAPIServiceArguments.start_time = start_time;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <Array<UpdateWithdrewListMutation>>response.data.updateWithdrewList;
  }
  async UpdateWithdrewListLinked(
    linked_time?: string
  ): Promise<Array<UpdateWithdrewListLinkedMutation>> {
    const statement = `mutation UpdateWithdrewListLinked($linked_time: String) {
        updateWithdrewListLinked(linked_time: $linked_time) {
          __typename
          member_no
          club_cd
          surname_cc
          firstname_cc
          surname_js
          firstname_js
          birthday
          post_no
          mail_address
          request_id
          processed_flag
          processed_time
          linked_flag
          start_time
          linked_time
          shop_name
          resume_flag
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (linked_time) {
      gqlAPIServiceArguments.linked_time = linked_time;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <Array<UpdateWithdrewListLinkedMutation>>(
      response.data.updateWithdrewListLinked
    );
  }
  async SelectMailAddress(
    mail_address: string
  ): Promise<Array<SelectMailAddressQuery>> {
    const statement = `query SelectMailAddress($mail_address: String!) {
        selectMailAddress(mail_address: $mail_address) {
          __typename
          request_id
          mail_address
          expiry_time
        }
      }`;
    const gqlAPIServiceArguments: any = {
      mail_address
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <Array<SelectMailAddressQuery>>response.data.selectMailAddress;
  }
  async GetRequestRecord(request_id: string): Promise<GetRequestRecordQuery> {
    const statement = `query GetRequestRecord($request_id: String!) {
        getRequestRecord(request_id: $request_id) {
          __typename
          request_id
          mail_address
          expiry_time
        }
      }`;
    const gqlAPIServiceArguments: any = {
      request_id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetRequestRecordQuery>response.data.getRequestRecord;
  }
  async SelectMailWithdrew(
    mail_address?: string
  ): Promise<Array<SelectMailWithdrewQuery>> {
    const statement = `query SelectMailWithdrew($mail_address: String) {
        selectMailWithdrew(mail_address: $mail_address) {
          __typename
          member_no
          club_cd
          surname_cc
          firstname_cc
          surname_js
          firstname_js
          birthday
          post_no
          mail_address
          request_id
          processed_flag
          processed_time
          linked_flag
          start_time
          linked_time
          shop_name
          resume_flag
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (mail_address) {
      gqlAPIServiceArguments.mail_address = mail_address;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <Array<SelectMailWithdrewQuery>>response.data.selectMailWithdrew;
  }
  async SelectWithdrew(
    surname_cc?: string,
    firstname_cc?: string,
    surname_js?: string,
    firstname_js?: string,
    birthday?: string,
    post_no?: string
  ): Promise<Array<SelectWithdrewQuery>> {
    const statement = `query SelectWithdrew($surname_cc: String, $firstname_cc: String, $surname_js: String, $firstname_js: String, $birthday: String, $post_no: String) {
        selectWithdrew(surname_cc: $surname_cc, firstname_cc: $firstname_cc, surname_js: $surname_js, firstname_js: $firstname_js, birthday: $birthday, post_no: $post_no) {
          __typename
          member_no
          club_cd
          surname_cc
          firstname_cc
          surname_js
          firstname_js
          birthday
          post_no
          mail_address
          request_id
          processed_flag
          processed_time
          linked_flag
          start_time
          linked_time
          shop_name
          resume_flag
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (surname_cc) {
      gqlAPIServiceArguments.surname_cc = surname_cc;
    }
    if (firstname_cc) {
      gqlAPIServiceArguments.firstname_cc = firstname_cc;
    }
    if (surname_js) {
      gqlAPIServiceArguments.surname_js = surname_js;
    }
    if (firstname_js) {
      gqlAPIServiceArguments.firstname_js = firstname_js;
    }
    if (birthday) {
      gqlAPIServiceArguments.birthday = birthday;
    }
    if (post_no) {
      gqlAPIServiceArguments.post_no = post_no;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <Array<SelectWithdrewQuery>>response.data.selectWithdrew;
  }
  async GetShopOperate(club_cd: string): Promise<GetShopOperateQuery> {
    const statement = `query GetShopOperate($club_cd: String!) {
        getShopOperate(club_cd: $club_cd) {
          __typename
          club_cd
          shop_name
          resume_flag
        }
      }`;
    const gqlAPIServiceArguments: any = {
      club_cd
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetShopOperateQuery>response.data.getShopOperate;
  }
  async SelectWithdrewAll(): Promise<Array<SelectWithdrewAllQuery>> {
    const statement = `query SelectWithdrewAll {
        selectWithdrewAll {
          __typename
          member_no
          club_cd
          surname_cc
          firstname_cc
          surname_js
          firstname_js
          birthday
          post_no
          mail_address
          request_id
          processed_flag
          processed_time
          linked_flag
          start_time
          linked_time
          shop_name
          resume_flag
        }
      }`;
    const response = (await API.graphql(graphqlOperation(statement))) as any;
    return <Array<SelectWithdrewAllQuery>>response.data.selectWithdrewAll;
  }
  async SelectWithdrewAllByClub(
    club_cd: string
  ): Promise<Array<SelectWithdrewAllByClubQuery>> {
    const statement = `query SelectWithdrewAllByClub($club_cd: String!) {
        selectWithdrewAllByClub(club_cd: $club_cd) {
          __typename
          member_no
          club_cd
          surname_cc
          firstname_cc
          surname_js
          firstname_js
          birthday
          post_no
          mail_address
          request_id
          processed_flag
          processed_time
          linked_flag
          start_time
          linked_time
          shop_name
          resume_flag
        }
      }`;
    const gqlAPIServiceArguments: any = {
      club_cd
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <Array<SelectWithdrewAllByClubQuery>>(
      response.data.selectWithdrewAllByClub
    );
  }
  async SelectWithdrew4Csv(): Promise<Array<SelectWithdrew4CsvQuery>> {
    const statement = `query SelectWithdrew4Csv {
        selectWithdrew4Csv {
          __typename
          member_no
          club_cd
          surname_cc
          firstname_cc
          surname_js
          firstname_js
          birthday
          post_no
          mail_address
          request_id
          processed_flag
          processed_time
          linked_flag
          start_time
          linked_time
          shop_name
          resume_flag
        }
      }`;
    const response = (await API.graphql(graphqlOperation(statement))) as any;
    return <Array<SelectWithdrew4CsvQuery>>response.data.selectWithdrew4Csv;
  }
  SelectWithdrewClubCdListener: Observable<
    Array<SelectWithdrewClubCdSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription SelectWithdrewClubCd {
        selectWithdrewClubCd {
          __typename
          member_no
          club_cd
          surname_cc
          firstname_cc
          surname_js
          firstname_js
          birthday
          post_no
          mail_address
          request_id
          processed_flag
          processed_time
          linked_flag
          start_time
          linked_time
          shop_name
          resume_flag
        }
      }`
    )
  ) as Observable<Array<SelectWithdrewClubCdSubscription>>;
}
